import React from "react";
import { Stack, Typography } from "@mui/material";
import { HubHookFormInput, HubHookFormSelect } from "../../components";
import { useFormContext } from "react-hook-form";

const defaultGap = 5 / 32;
const defaultMargin = {
  top: 0.5,
  left: defaultGap,
  bottom: 0.5,
  right: defaultGap,
};

const pageOptions = [
  { id: 0, label: "Roll" },
  { id: 1, label: "Letter" },
];

const BarcodePageSettings = ({ disabled }) => {
  const { watch } = useFormContext();
  const pageType = watch("pageType");
  const display = pageType ? {} : { display: "none" };

  return (
    <Stack width="100%" gap="5px">
      <Typography variant="boldCaptionMain">Page Settings</Typography>
      <Stack width="100%" gap="15px">
        <HubHookFormSelect
          name="pageType"
          label="Page Type"
          options={pageOptions}
          required
        />
        <Stack width="100%" gap="15px" sx={display}>
          <Stack direction="row" gap="5px">
            {Object.keys(defaultMargin).map((key) => (
              <HubHookFormInput
                name={`margin.${key}`}
                label={`Margin ${key}`}
                placeholder={`${defaultMargin[key]}`}
                disabled={disabled}
                endAdornment="in"
                required
              />
            ))}
          </Stack>
          <Stack direction="row" gap="5px">
            <HubHookFormInput
              name="columnGap"
              label="Horizontal Spacing"
              placeholder={defaultGap}
              disabled={disabled}
              endAdornment="in"
              isDecimal
              required
            />
            <HubHookFormInput
              name="rowGap"
              label="Vertical Spacing"
              placeholder={"0"}
              disabled={disabled}
              endAdornment="in"
              isDecimal
              required
            />
            <HubHookFormInput
              name="columns"
              label="Columns"
              placeholder={3}
              disabled={disabled}
              isNumber
              required
            />
            <HubHookFormInput
              name="rows"
              label="Rows"
              placeholder={10}
              disabled={disabled}
              isNumber
              required
            />
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default BarcodePageSettings;
